import { useEffect, useRef } from "react";

const Calendly = ({ url, height = "500px" }) => {
  const ref = useRef();

  useEffect(() => {
    if (!document.getElementById("calendly-script")) {
      const script = document.createElement("script");
      script.id = "calendly-script";
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div
      ref={ref}
      className="calendly-inline-widget"
      data-url={url}
      style={{ minWidth: '500px', height: height, width:'100%'}}
    />
  );
};

export default Calendly;